import 'css-chunk:src/feature/settings/SettingsLatencyTest.module.scss';export default {
  "root": "SettingsLatencyTest_root"
};